import PropTypes from 'prop-types';
import React from 'react';
export default function CloseBigIcon(_a) {
    var display = _a.display;
    var className = "display-".concat(display);
    return (React.createElement("svg", { className: className, height: "10", viewBox: "0 0 10 10", width: "10" },
        React.createElement("path", { d: "M5 3.438l-3.116-3.116c-.428-.428-1.13-.431-1.56 0-.434.434-.431 1.129 0 1.56l3.116 3.116-3.116 3.116c-.431.431-.434 1.127 0 1.56.431.431 1.132.428 1.56 0l3.116-3.116 3.116 3.116c.428.428 1.13.431 1.56 0 .434-.434.431-1.129 0-1.56l-3.116-3.116 3.116-3.116c.431-.431.434-1.127 0-1.56-.431-.431-1.132-.428-1.56 0z" })));
}
CloseBigIcon.propTypes = {
    display: PropTypes.oneOf(['inline', 'block', 'inlineBlock']),
};
CloseBigIcon.defaultProps = {
    display: 'inline',
};
